import { Injectable, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: "root"
})
export class AutenticacaoService {

  public userSubject = new Subject<any>();

  constructor(
              private router: Router,
              private http: HttpClient,
              private cookieService: CookieService) {

              }

  public login(cpf: string, senha: string, recaptchaV2Token: string, recaptchaV3Token: string): Observable<any>{
    return this.http
          .post(`${environment.apiURL}/Autenticacao/Login/Logar`, {cpf: cpf, senha: senha, recaptchaV2Token: recaptchaV2Token, recaptchaV3Token: recaptchaV3Token})
          .pipe(
            map(credenciais => {

              this.setCredenciais(credenciais);

              this.userSubject.next(credenciais);

              return credenciais;
            }
          ));
  }

  public esqueciMinhaSenhaEnviarTokenEmail(cpf: string, email: string){
    return this.http
          .post(`${environment.apiURL}/Autenticacao/Login/EsqueciMinhaSenhaEnviarTokenEmail`, {cpf: cpf, email: email});
  }

  public esqueciMinhaSenha(token: string, senha: string, senhaConfirmacao: string){
    return this.http
          .post(`${environment.apiURL}/Autenticacao/Login/EsqueciMinhaSenha`, {token: token, senha: senha, senhaConfirmacao: senhaConfirmacao});
  }

  public reenviarTokenEmail(cpf: string, email: string){
    return this.http
          .post(`${environment.apiURL}/Autenticacao/Login/ReenviarTokenEmail`, {cpf: cpf, email: email});
  }

  public logout(){
    this.removeCredenciais();
    this.userSubject.next(null);
  }

  public setCredenciais(credenciais: any){
    this.cookieService.set("access_token", credenciais.token, undefined, "/");
    localStorage.setItem("credenciais", JSON.stringify(credenciais));
  }

  public getCredenciais(): any{
    return JSON.parse(localStorage.getItem("credenciais"));
  }

  public getToken(): string {
    return this.cookieService.get("access_token");
  }

  public removeCredenciais() {
    this.cookieService.delete("access_token", "/");
    localStorage.removeItem("credenciais");
  }

  public isAuthenticated(): boolean {
    return (this.cookieService.get("access_token") != "" && localStorage.getItem("credenciais") != null);
  }


}
